// extracted by mini-css-extract-plugin
export var container = "YoutubeEmbed-module--container--S9ed0";